import { Chip } from "@mui/material";
import { t } from "i18next";
import React from "react";

const CorePracticeTags = ({ practiceDocuments }) => {
  return (
    <div className="flex p-1 items-center gap-2">
      <h5 className="m-0">{`${t("PresentIn")} ${practiceDocuments?.length} ${t(
        "practice"
      )}:`}</h5>
      <div
        style={{
          border: "1px solid #f1f1f1",
          maxWidth: "400px",
          borderRadius: "10px",
        }}
        className="flex overflow-x-auto p-2 gap-2"
      >
        {practiceDocuments.map((practice) => (
          <Chip label={practice.name} size="small" color="info" />
        ))}
      </div>
    </div>
  );
};

export default CorePracticeTags;
